// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Messaging_establishments__13bpp","header":"Messaging_header__3vgPu","tableHeader":"Messaging_tableHeader__3KgE3"};